import { render } from "./ShowMessageModal.vue?vue&type=template&id=20373bb3&scoped=true"
import script from "./ShowMessageModal.vue?vue&type=script&lang=js"
export * from "./ShowMessageModal.vue?vue&type=script&lang=js"

import "./ShowMessageModal.vue?vue&type=style&index=0&id=20373bb3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20373bb3"]])

export default __exports__